define.alias("shared/components/shared/post/secondary/caption-writer/footer", "preview-grid/components/shared/post/secondary/caption-writer/footer");